/**
 * Small bilingual timezone label helper.
 * Follows the language selected in the Ridalo interface (i18next), so the
 * note matches the rest of the page.
 * Used to reassure international travelers that all times shown
 * refer to local Thailand time (UTC+7).
 */
import i18n from '@/i18n';

const isFrench = () => {
  const lang = (i18n.resolvedLanguage || i18n.language || 'fr').toLowerCase();
  return !lang.startsWith('en');
};

// Resolve the user's local timezone label (e.g. "GMT+2", "GMT+7").
const localTzLabel = () => {
  try {
    const parts = new Intl.DateTimeFormat(isFrench() ? 'fr-FR' : 'en-US', { timeZoneName: 'short' }).formatToParts(new Date());
    return parts.find((p) => p.type === 'timeZoneName')?.value || '';
  } catch { return ''; }
};

export const getTimezoneLabel = () => {
  const tz = localTzLabel();
  if (isFrench()) {
    return `Affichage dans votre fuseau horaire${tz ? ` (${tz})` : ''} — Thaïlande UTC+7 pour l'heure de service`;
  }
  return `Displayed in your local timezone${tz ? ` (${tz})` : ''} — Thailand UTC+7 for service time`;
};

/**
 * Ready-to-use React fragment — small discrete gray text.
 * Import as: <TimezoneNote /> and drop next to any date/time display.
 */
import React from 'react';
export const TimezoneNote = ({ className = '' }) => (
  <p
    className={`text-xs text-ink-muted italic ${className}`}
    data-testid="timezone-note"
  >
    {getTimezoneLabel()}
  </p>
);
